import React from 'react';
import Image from 'next/image';

import styles from './testimonial-card.module.scss';

const TestimonialCard = ({
    quote,
    author,
    iconSrc,
}: {
    quote: string;
    author: string;
    iconSrc: string;
}) => {
    return (
        <div className={styles['testimonial-card']}>
            <div className={styles['testimonial-body']}>
                <div className={styles['testimonial-content']}>
                    <Image
                        src={iconSrc}
                        className={styles['testimonial-icon']}
                        alt="Quote icon"
                        width={16}
                        height={16.825}
                    />
                    <div className={styles['testimonial-text-container']}>
                        <div className={styles['testimonial-quote']}>{quote}</div>
                        <div className={styles['testimonial-author']}>{author}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {TestimonialCard};
